export interface IContainer {
  get<T>(id: Symbol): T;
}

type Func<T> = () => T;


export class ComponentContainer implements IContainer {
  private _delegates: {
    [key: string]: Func<any>;
  };

  

  constructor() {
    this._delegates = {};
  }

  public register<T>(id: Symbol, resolve: Func<T>) {
    this._delegates[id.toString()] = resolve;
  }

  public get<T>(id: Symbol): T {
    const factory = this._delegates[id.toString()];

    return factory();
  }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/services/container.ts